import styled from 'styled-components';

export const HistoryPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 320px);
  width: 100%;
  
  
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  height: 100%;
`;

export const HistoryGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HistoryGroupTitle = styled.div`
  margin-bottom: 8px;
`;

export const HistoryItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
 
  }
`;

export const HistoryItemText = styled.div`
  flex: 1;
`;

